/* eslint-disable react/require-default-props */
import React, { ReactElement } from 'react';
import { useSelector , useDispatch } from 'react-redux';
import {
  ElearningPlayerStateType,
  actions as ElearningPlayerActions,
} from '@/components/Player/modules/reducers/elearningPlayer';

import MenuView from './MenuView';
import './Menu.scss';

const Menu = (): ReactElement => {
  const dispatch = useDispatch();

  const {
    isVisibleMenu,
    content: { frames, elearning, currentFrameId },
    handlers: { moveToFrame },
  }: ElearningPlayerStateType = useSelector(
    (state: { elearningPlayer: ElearningPlayerStateType }) =>
      state.elearningPlayer,
  );
  const closeMenuHandler = () => {
    dispatch({
      type: ElearningPlayerActions.closeMenu.type,
    });
  };
  const frameNavigationHandler = (nextFrameId: string) => {
    moveToFrame(nextFrameId);
    closeMenuHandler();
  };
  return (
    <MenuView
      isVisible={isVisibleMenu}
      frames={frames}
      closeMenu={closeMenuHandler}
      frameId={currentFrameId}
      elearningId={elearning?.id}
      onClickLink={frameNavigationHandler}
    />
  );
};

export default Menu;
